import { NgModule } from '@angular/core';
import { RouterModule, Routes }     from '@angular/router';
import { CommonModule }             from '@angular/common';
import { FormsModule }              from '@angular/forms';


import { AuthGuard }                    from '../_services/auth.guard';
import { MycourseComponent }            from './mycourse.component';
import { ProfileComponent }             from './profile.component';
//import { PurchaseComponent }            from './purchase.component';
//import { SettingComponent }             from './setting.component';
//import { NotificationComponent }        from './notification.component';
//import { PasswordComponent }            from './password.component';

import {MatProgressBarModule} from '@angular/material/progress-bar';

/*Materials*/
import {MatIconModule, MatCardModule} from '@angular/material';
import { LazyLoadImagesModule } from 'ngx-lazy-load-images';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    imports: [
        CommonModule,
        LazyLoadImagesModule,
        MatInputModule,
        MatIconModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatCardModule, 
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatDividerModule,
        FormsModule,
        RouterModule.forChild([
        	{path: 'mycourse', component: MycourseComponent, canActivate: [AuthGuard]},
            {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
            //{path: 'purchase', component: PurchaseComponent, canActivate: [AuthGuard]},
            //{path: 'setting', component: SettingComponent, canActivate: [AuthGuard]},
            //{path: 'change-password', component: PasswordComponent, canActivate: [AuthGuard]},
            //{path: 'notification', component: NotificationComponent, canActivate: [AuthGuard]},
        ])
    ],
     declarations: [MycourseComponent, ProfileComponent
     //, PurchaseComponent, SettingComponent,PasswordComponent,NotificationComponent
     ]
})
export class ProfileModule {}

